import { atom , useSetRecoilState} from "recoil";


export const transactionmasterDataAtom = atom({key:'transactionmasterDataAtom',default:{}});


export  const SetTransactionMasterData = () => useSetRecoilState(transactionmasterDataAtom);
// export const UseCurrentMenuState = () => useSetRecoilState(transactionAtom);
// export const CurrentMenuList = () => useRecoilValue(transactionAtom);
